<template>
  <div id="professional_certs_outer" v-if="judgeItem != null || coachItem != null">
<!--    <div style="margin-left: 10px;">-->
<!--      <a class="add-certs-view noraml-click-link" href="javascript:void(0)" @click="addNewCert">认证更多身份<span class="iconfont">&#xf0154;</span></a>-->
<!--    </div>-->

    <div id="certificates_list_view" :class="{'top-bottom-gold_border_color' : isVip, 'top-bottom-red_border_color': !isVip, 'left-right-red_border_color': !isVip, 'left-right-gold_border_color' : isVip}">
      <table v-if="tableWidth != null"  :class="['table', 'table-striped', {  }]" >
        <thead>
        <tr>
          <td v-for="(item, index) in tableHeaderList" v-if="tableTdShow(index)" :key="'certs_head_label' + index">{{item}}</td>
        </tr>
        </thead>
        <tbody>
          <tr v-if="judgeItem!= null">
            <td v-if="tableTdShow(0)">裁判员</td>
            <td v-if="tableTdShow(1)">{{judgeItem.certificateLevel}}</td>
            <td v-if="tableTdShow(2)">{{judgeItem.yearOfApproval}}</td>
            <td v-if="tableTdShow(3)">
              {{(judgeItem.certificateNo == null || judgeItem.certificateNo == '') ? '无' : judgeItem.certificateNo}}
            </td>
            <td v-if="tableTdShow(4)">
              {{judgeItem.unitOfApproval}}
            </td>
            <td v-if="tableTdShow(5)">
              <template v-if="isJudgeApplyAllowed">
                <a v-if="linkClickedEnable(judgeItem)" :class="[ isEditColunmsAvailable ? 'red-click-link' : 'disable-click-link']" @click="certItemClicked(judgeItem)">{{showYearCheckText(judgeItem)}}</a>
                <span v-else-if="isJudgeSuccess(judgeItem)" class="success-label">本年度年检合格</span>
                <span v-else :class="[ isEditColunmsAvailable ? 'noraml-click-link' : 'disable-click-link']">{{showYearCheckText(judgeItem)}}</span>
              </template>
              <template v-else>
                <span v-if="isJudgeSuccess(judgeItem)" class="success-label">本年度年检合格</span>
                <span v-else :class="[ isEditColunmsAvailable ? 'noraml-click-link' : 'disable-click-link']">{{showYearCheckText(judgeItem)}}</span>
              </template>
            </td>
          </tr>

          <tr v-if="coachItem != null" >
            <td v-if="tableTdShow(0)">教练员</td>
            <td v-if="tableTdShow(1)">{{ coachItem.certificates[0].level }}</td>
            <td v-if="tableTdShow(2)">{{ $moment(coachItem.certificates[0].dateOfIssue).format('yyyy') }}</td>
            <td v-if="tableTdShow(3)">
              {{ coachItem.certificates[0].sn }}
            </td>
            <td v-if="tableTdShow(4)">
              {{ coachItem.certificates[0].unit }}
            </td>
            <td v-if="tableTdShow(5)">
              <a class="red-click-link" href="javascript:void(0)" @click="coachItemClcicked(coachItem)">重新认证</a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>


  </div>
</template>

<script>
export default {
  name: "ProfessionalCertsList",
  data() {
    return {
      tableWidth: null,

      tableHeaderList: [
        "职业类型",
        "证书级别",
        "批准年份",
        "证书编号",
        "发证单位",
        "操作"
      ],
      caochData: null,
      judgeItem: null,
      coachItem: null,

      tempJudgeList: null,
      judgeApplyDuration: null,
      isEditColunmsAvailable: false,
    }
  },
  computed: {
    httpManager() {
      return this.$store.state.http;
    },
    user() {
      return this.$store.state.user;
    },

    isJudgeApplyAllowed() {
      let judgeApplyDuration = this.judgeApplyDuration;
      if (judgeApplyDuration == null) {
        return false;
      }
      let beginString = judgeApplyDuration.begin;
      let enditString = judgeApplyDuration.end;
      let beginDate = this.$moment(beginString);
      let endDate = this.$moment(enditString);
      let now = this.$moment(this.$moment().format("yyyy-MM-DD"), "yyyy-MM-DD");
      if ((now - beginDate) >= 0 && (now - endDate) <= 0) {
        return true;
      }
      return false;
    },

    isVip() {
      if (this.user == null) {
        return false;
      }
      let user = this.user;
      let memberValidDate = user.memberValidDate;
      if (memberValidDate == null) {
        return false;
      }
      return this.$moment(memberValidDate).add('1','days').add('-1', 'seconds').isAfter(this.$moment());
    },
  },

  mounted() {
    $(window).resize(this.updateConfigureValues);
    this.updateConfigureValues();
    this.loadJudgeListData();
    this.loadCoachData();
    this.getJudgeIdentificationDateDuration();
  },

  methods: {
    updateConfigureValues() {
      let width  = $("#certificates_list_view").width();
      if (width == undefined || width == 0) {
        let _this = this;
        setTimeout(function () {
          _this.updateConfigureValues();
        },50);
        return;
      }
      this.tableWidth = width;
    },

    showYearCheckText(item) {
      if (item == null) {
        return '数据异常';
      }

      let status = item.status;
      let reviewed = item.reviewed;
      if (item.auditStatus == 0) { // 已结束的item
        if (reviewed != 0) {
          if (status == 6) {
            return '本年度年检合格';
          } else  {
            return '考核已结束';
          }
        } else {
          return '立即年检';
        }
      } else { // 未结束的...
        let staminaTest = item.staminaTest;
        if (staminaTest == null) {
          staminaTest = '未进行';
        }
        let theoryTest = item.theoryTest;
        if (theoryTest == null) {
          theoryTest = '未进行';
        }
        if (status == 5) {
          if (theoryTest == '已通过' && staminaTest == '已通过') {
            return '本年度年检合格'
          } else if (theoryTest == '未进行' && staminaTest == '未进行') {
            return '未考核';
          } else if (theoryTest == '未通过' || staminaTest == '未通过') {
            return '考核已结束';
          } else {
            return '考核中';
          }
        } else {
          return '立即年检';
        }
      }
    },

    tableTdShow(index) {
      let width = this.tableWidth;
      if (width == null) {
        return true;
      }
      let list = []; // 要隐藏的列
      if ( width > 738) {
        list = [];
      } else if (width > 600) {
        list = [];
      } else if (width > 500) {
        list = [3];
      } else if (width > 410) {
        list = [3,4];
      } else if(width >= 320) {
        list = [3, 4];
      } else {
        list = [3, 4];
      }
      if (list.indexOf(index) != -1) {
        return false;
      }
      return true;
    },
    addNewCert() {
      this.$router.push({
        name: 'personalCertificateApplicationVue',
        params: {
          certId: 0
        }
      })
    },

    getJudgeIdentificationDateDuration() {
      let judgeApplyDuration = this.judgeApplyDuration;
      if (judgeApplyDuration == null) {
        let _this = this;
        this.httpManager.ajax.getJudgeApplyDateData(function (data) {
          if (data.code == 0) {
            let value = data.data.value;
            let duration = JSON.parse(value);
            _this.judgeApplyDuration = duration;
            _this.isEditColunmsAvailable = _this.isJudgeApplyAllowed;
            _this.filterCompletedJudgeItem();
            return;
          }
        }, function (data) {

        });
      }
    },

    certItemClicked(item) {
      this.$router.push({
        name: 'personalCertificateApplicationVue',
        params: {
          certId: item.id
        },
      })
    },

    coachItemClcicked(item) {
      this.$router.push({
        name: 'personalCoachCertApplicationVue',
        params: {
          certId: item.coach.id
        }
      });
    },

    loadCoachData() {
      let user = this.user;
      let _this = this;
      if (user == null) {

        setTimeout(function() {
          _this.loadCoachData();
        },100);
        return;
      }
      let params = {
        userId: user.id
      };

      this.httpManager.ajax.getUserCoachListData(params, function(data) {
        let code = data.code;
        if (code == 0) {
          _this.caochData = data.data;
          _this.dealWithCoachData();
        }
      }, function(data) {

      });
    },

    dealWithCoachData() {
      let coachData = this.caochData;
      console.log(coachData);
      if (coachData == null || coachData.length == 0) {
        return;
      }

      for (let i = 0; i < coachData.length; i++) {
        let item = coachData[i];
        let coach = item.coach;
        if (coach == undefined || coach == null) {
          continue;
        }
        if (coach.status == 7) {
          this.coachItem = item;
          break;
        }
      }
    },

    loadJudgeListData() {
      let _this = this;
      this.httpManager.ajax.getJudgeListSelfData(function (data) {
        let code = data.code;
        // console.log(data);
        if (code == 0) {
          let judgeList = data.data;

          _this.tempJudgeList = judgeList;
          _this.$store.commit('setJudgeList', judgeList);
          _this.filterCompletedJudgeItem();
        }
      }, function () {
      });
    },
    filterCompletedJudgeItem() {
      if (this.tempJudgeList == null || this.judgeApplyDuration == null) {
        return;
      }

      let jugdeList = this.tempJudgeList;
      console.log(jugdeList);

      if (jugdeList != null && jugdeList.length > 0) {
        let judgeItem = null;
        let firstItem = jugdeList[0];
        if (firstItem.reviewed == 0) { // 增加一个判断机制：把往年未完成的年检的status 置为6
          let updatedTime = firstItem.updatedTime;
          if (updatedTime != null) {
            let number =  this.$moment().year() - this.$moment(updatedTime).year();
            if (number > 1) {
              firstItem.status = 6;
            }
          }
        }

        if (firstItem.status == 6 || firstItem.reviewed != null) {
          firstItem.imageArray = this.splitImages(firstItem.certificatePhoto);
          judgeItem = firstItem;
        } else {
          if (firstItem.status >= 5 && firstItem.status < 7) {
            firstItem.imageArray = this.splitImages(firstItem.certificatePhoto);
            judgeItem = firstItem;
          }
        }
        console.log('----3');
        this.judgeItem = judgeItem;
      }
    },
    splitImages(imageStr) {
      let imageArray = [];
      if (imageStr != null && imageStr.length > 0) {
        let tmpArray = imageStr.split(',');
        for (let i = 0; i < tmpArray.length; i++) {
          let item = tmpArray[i];
          if (item.length > 0) {
            imageArray.push(item);
          }
        }
      }
      return imageArray;
    },


    linkClickedEnable(item) {
      if (item == null) {
        return false;
      }
      if (item.auditStatus == 1) {
        return true;
      } else {
        if (item.reviewed == 0) {
          return true;
        }
        return false;
      }
    },

    isJudgeSuccess(item) {
      if (item != null) {
        if (item.auditStatus == 1) { // 在年检中
          let staminaTest = item.staminaTest;
          if (staminaTest == null) {
            staminaTest = '未进行';
          }
          let theoryTest = item.theoryTest;
          if (theoryTest == null) {
            theoryTest = '未进行';
          }
          if (item.status == 5 && theoryTest == '已通过' && staminaTest == '已通过') {
            return true;
          }
        } else { // 非年检中
          if (item.reviewed != 0 && item.status == 6) {
            return true;
          }
        }
      }
      return false;
    },
  }
}
</script>

<style scoped>
  #professional_certs_outer {
    padding-left: 5px;
    padding-right: 5px;
    margin-top: 15px;
  }

  #certificates_list_view {
    min-height: 250px;
    margin-top: 15px;
    padding-top: 15px;
    padding-bottom: 15px;
  }

  #certificates_list_view .table {
    text-align: center;
  }

  #certificates_list_view .table thead tr > td {
    font-weight: bold;
    border-bottom: solid 1px #eeeeee;
    padding: 15px 0;
  }

  #certificates_list_view .table tbody tr > td {
    border: none;
    /*padding-top: 10px;*/
    /*padding-bottom: 10px;*/
    border-bottom: solid 1px #eeeeee;
    padding: 10px 0;
    vertical-align: middle;
  }

  #professional_certs_outer .left-right-gold_border_color {
    border-left: solid 1px #cbb042;
    border-right: solid 1px #cbb042;
  }

  #professional_certs_outer .left-right-red_border_color {
    border-left: solid 1px #e71432;
    border-right: solid 1px #e71432;
  }

  #professional_certs_outer .top-bottom-gold_border_color {
    border-top: solid 1px #cbb042;
    border-bottom: solid 1px #cbb042;
  }

  #professional_certs_outer .top-bottom-red_border_color {
    border-top: solid 1px #e71432;
    border-bottom: solid 1px #e71432;
  }

  #professional_certs_outer .add-certs-view span {
    margin-left: 5px;
    font-size: 1rem;
    padding: 0;
  }

  #professional_certs_outer .noraml-click-link {
    text-decoration: none;
  }

  #professional_certs_outer .red-click-link {
    color: #e71432;
    text-decoration: none;
  }

  #professional_certs_outer a.red-click-link:hover {
    color: gray;
  }

  #professional_certs_outer .disable-click-link {
    pointer-events: none;
    color: lightgrey;
  }

  #professional_certs_outer a.noraml-click-link:hover {
    color: #e71432;
  }

  #professional_certs_outer .table .el-image {
    width: 60px;
    height: auto;
    max-height: 100px;
  }

  #professional_certs_outer .success-label {
    font-size: smaller;
    text-align: center;
    vertical-align: middle;
    color: green;
    padding: 1px 3px;
    border: solid 1px green;
  }

</style>



// WEBPACK FOOTER //
// src/pages/ProfessionalCertsList.vue